/* --- PRIVATE --- */
const isSideRelated = (extremity, showLeft, showRight) => {
  extremity = extremity.toLowerCase();
  if (extremity === "left knee" && !showLeft) return false
  if (extremity === "right knee" && !showRight) return false
  if ((extremity === "right flexion" || extremity === "right extension" ) && !showRight) return false
  if ((extremity === "left flexion" || extremity === "left extension" ) && !showLeft) return false
  return true;
};

const splitExtremityValues = (values) => {
  const sourceValues = Array.isArray(values) ? values : [values];
  const extremities = sourceValues.reduce(
    (extremities, value) =>
      extremities.concat(
        String(value || "")
          .split(";")
          .map((extremity) => extremity.trim())
          .filter(Boolean)
      ),
    []
  );

  return extremities.length > 0 ? extremities : [""];
};

/* Filters original question  */
export const filterByRelatedExtremity = (questions, diagnosesAndExtremities) => {

  if (!diagnosesAndExtremities) {
    return questions;
  }

  let showBoth = false
  let showLeft = false
  let showRight = false  

  //Filter and map through the diagnosis extremity value
  const extremities = diagnosesAndExtremities.reduce((values, element) => {
    const extremity =
      element &&
      (element.extremity || element.fbsg_extremities_selector_c);

    return values.concat(splitExtremityValues(extremity));
  }, [])

  extremities.forEach(extremity => {
    if (!extremity) showBoth = true //Edge case, handles user error on empty extremity field
    if (extremity === "Bilateral Lower Extremities" || extremity === "Bilateral Lower") showBoth = true
    if (extremity === "Left Lower Extremity" || extremity === "Left Lower") showLeft = true
    if (extremity === "Right Lower Extremity" || extremity === "Right Lower") showRight = true
  })

  //Returns original question, needs to test both knees
  if (showBoth || (!showBoth && !showLeft && !showRight)) return questions;

  //Loops through all questions related to the disability and checks:
  questions = questions.filter((question) => {
    //1. If "redHeading" doesn't match the extremity selected, then it will remove the question
    if (question.redHeading) {
      if (!isSideRelated(question.redHeading, showLeft, showRight)) return false;
    }
    //2. If the question has inner questions, check the "label" of the inner question for a match in the extremity, else remove the inner question
    if (question.questions) {
      question.questions = question.questions.filter((question) => {
        if (question.label) {
          if (!isSideRelated(question.label, showLeft, showRight)) return false;
        }
        if (question.main){
          if (!isSideRelated(question.main, showLeft, showRight)) return false;
        }
        if (question.title) {
          return isSideRelated(question.title, showLeft, showRight);
        }
        return true;
      });
    }
    return true;
  });

  return questions;
};
